import BrandSignature from './BrandSignature';

function ProjectsPage({ brandLogo, onProjectSelect, openHomePage, projects }) {
  return (
    <section className="projects-page">
      <div className="page-head">
        <button
          aria-label="Back to home"
          className="page-head-back"
          onClick={openHomePage}
          type="button"
        >
          <BackArrowIcon />
        </button>
        <div className="page-head-copy">
          <p className="eyebrow">Show Demo Project</p>
          <h1>Explore Our UI/UX Showcase Projects</h1>
          <p className="hero-text">
            Browse through our collection of UI/UX showcase projects. Click the shopping app card
            to open the full live demo on its own page inside ATA Code House.
          </p>
        </div>
      </div>

      <div className="demo-card-grid">
        {projects.map((project) => (
          <button className="demo-launch-card" key={project.id} onClick={onProjectSelect} type="button">
            <div className="demo-launch-shell">
              <div className="demo-launch-phone">
                <div className="demo-launch-screen">
                  <div className="demo-launch-header">
                    <BrandSignature brandLogo={brandLogo} compact label="ATA Code House" />
                  </div>
                  <div className="demo-skeleton-banner" />
                  <div className="demo-skeleton-row">
                    <span />
                    <span />
                    <span />
                  </div>
                  <div className="demo-skeleton-grid">
                    <span />
                    <span />
                    <span />
                    <span />
                  </div>
                </div>
              </div>
            </div>
            <strong style={project.title === 'Shopping App' ? { color: 'white' } : {}}>
              {project.title}
            </strong>
            <small>{project.label}</small>
          </button>
        ))}
      </div>
    </section>
  );
}

function BackArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M14.5 5 7.5 12l7 7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 12h8.5" strokeLinecap="round" />
    </svg>
  );
}

export default ProjectsPage;
